import React, { Component } from 'react';

import axios from "axios"

import FormField from "../Components/FormField"

import './Signup.css';
import swal from 'sweetalert';



let api = "https://vendor.lushplans.com/"
export default class Signup extends Component {
  constructor(props) {
    super(props)    
    
    this.nigeriaPriceRanges = [
        "25,000 and below",
        "25,000 - 50,000",
        "50,000 - 100,000",
        "100,000 - 250,000",
        "250,000 - 400,000",
        "400,000 - 600,000",
        "600,000 - 1,000,000",
        "1,000,000 - 2,000,000",
        "2,000,000 - 4,000,000",
        "4,000,000 and above"
      ]
    
    
    this.nigeriaPriceRanges = this.nigeriaPriceRanges.map((item, index) => {
      return { label : item, value : item }
    })

    this.usPriceRanges = [
      "1,000 and below",
      "1,000 - 5,000",
      "5,000 - 15,000",
      "15,000 - 30,000",
      "30,000 - 50,000",
      "50,000 - 100,000",
      "100,000 - 250,000",
      "250,000 - 500,000",
      "500,000 - 1,000,000",
      "1,000,000 and above"
      ]

    this.usPriceRanges = this.usPriceRanges.map((item, index) => {
      return { label : item, value : item }
    })    

    let countryList = ["Afghanistan","Albania","Algeria","Andorra","Angola","Anguilla","Antigua &amp; Barbuda",
                       "Argentina","Armenia","Aruba","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados",
                       "Belarus","Belgium","Belize","Benin","Bermuda","Bhutan","Bolivia","Bosnia &amp; Herzegovina","Botswana","Brazil",
                       "British Virgin Islands","Brunei","Bulgaria","Burkina Faso","Burundi","Cambodia","Cameroon","Cape Verde","Cayman Islands",
                       "Chad","Chile","China","Colombia","Congo","Cook Islands","Costa Rica","Cote D Ivoire","Croatia","Cruise Ship","Cuba","Cyprus",
                       "Czech Republic","Denmark","Djibouti","Dominica","Dominican Republic","Ecuador","Egypt","El Salvador","Equatorial Guinea","Estonia",
                       "Ethiopia","Falkland Islands","Faroe Islands","Fiji","Finland","France","French Polynesia","French West Indies","Gabon","Gambia",
                       "Georgia","Germany","Ghana","Gibraltar","Greece","Greenland","Grenada","Guam","Guatemala","Guernsey","Guinea","Guinea Bissau",
                       "Guyana","Haiti","Honduras","Hong Kong","Hungary","Iceland","India","Indonesia","Iran","Iraq","Ireland","Isle of Man","Israel",
                       "Italy","Jamaica","Japan","Jersey","Jordan","Kazakhstan","Kenya","Kuwait","Kyrgyz Republic","Laos","Latvia","Lebanon","Lesotho",
                       "Liberia","Libya","Liechtenstein","Lithuania","Luxembourg","Macau","Macedonia","Madagascar","Malawi","Malaysia","Maldives","Mali",
                       "Malta","Mauritania","Mauritius","Mexico","Moldova","Monaco","Mongolia","Montenegro","Montserrat","Morocco","Mozambique","Namibia",
                       "Nepal","Netherlands","Netherlands Antilles","New Caledonia","New Zealand","Nicaragua","Niger","Nigeria","Norway","Oman","Pakistan",
                       "Palestine","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Poland","Portugal","Puerto Rico","Qatar","Reunion","Romania",
                       "Russia","Rwanda","Saint Pierre &amp; Miquelon","Samoa","San Marino","Saudi Arabia","Senegal","Serbia","Seychelles",
                       "Sierra Leone","Singapore","Slovakia","Slovenia","South Africa","South Korea","Spain","Sri Lanka","St Kitts &amp; Nevis","St Lucia",
                       "St Vincent","St. Lucia","Sudan","Suriname","Swaziland","Sweden","Switzerland","Syria","Taiwan","Tajikistan","Tanzania","Thailand",
                       "Timor L'Este","Togo","Tonga","Trinidad &amp; Tobago","Tunisia","Turkey","Turkmenistan","Turks &amp; Caicos","Uganda","Ukraine",
                       "United Arab Emirates","United Kingdom","Uruguay","Uzbekistan","Venezuela","Vietnam","Virgin Islands (US)","Yemen","Zambia","Zimbabwe"];
                       
    countryList = countryList.map((item, index) => {
      return { label : item }
    })

    let vendorTypes = ["alaga","asoebi","asoebibella","attire","bead","beautiful","bridal dress","bridal gown","bridal stylist",
                       "brides outfit","brides robe","brides shoes","bridesmaid dresses","bridesmaids","bridesmaids hair","bridesmaids makeup",
                       "caterer","cinematographer","clutch","cocktails","coordination","coordinator","couple","creative director","decorator",
                       "design brand","dessert","desserts","dress designer","drinks","earrings","eru iyawo","fascinator","fashion illustrator",
                       "florals","florist","flowers","food","gown","grooms outfit","grooms shoes","grooms suit","grooms tuxedo","groomsmen suit",
                       "groomtobe","hair piece","hairstylist","headpiece","henna","hotel","ig","instagram","jewellery","kente","lashes","live band",
                       "lovely","makeup artist","mc","model","models","muse","music","nails","outfits","photobooth","planners","ring","robe","see",
                       "shoes","special effect","spotted","stationery","studio","suit","suits","thank you","tiara","to","turban","us","venue",
                       "wedding coordinator","wedding dress"]
    vendorTypes = vendorTypes.map((item, index) => {
      return { label : item.replace(/\w\S*/g, function(txt){
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        })}
    })
    this.state = {      
      currentTab : 0,
      disableNextTabButton : false,
      nextButtonText : "NEXT",
      forms : [],
      showReviewPage : false,
      showTabs : true,
      showErrorMessage : false,      
      errorMessage : "",
      priceRange : this.nigeriaPriceRanges,      
      data : {
        email : "",
        password : "",
        currency : "naira"
      },
      data_status : {
        
      },
      contactForm : {
        title : "Contact Information",
        score : 1250,
        form : [
        {
          name: "name",
          label: "Business Name",
          type: "text",        
        },
        {
          name : "phone",
          label : "Phone Number (Include country code)",
          type : "tel"
        },
        {
          name: "email",
          label: "Email",
          type: "email",
        },
        {
          name: "password",
          label: "Password",
          type: "password",
          // grid_css: "no-gutters",
          // field_grid_size: "12",
          // input_css : "mb-5"
        }
      ]},
      locationForm : {
        title : "Location Information",
        score : 1250,
        form : [
          {
            name: 'country',
            label: 'Country',
            type : "text",
            meta : {
              autocomplete : true,
              options : countryList
            }
          },
          {
            name: 'state',
            label: 'State/Province',        
            type : "text"
          },
          {
            name: 'city',
            label: 'City',        
            type : "text"
          },
          {
            name: 'street',
            label: 'Address (Street No. and Name)',  
            type : "text"      
          },
          {
            name: 'postalcode',
            label: 'Postal/Zip Code',        
            type : "text"
          },
        ]
      },
      socialMediaForm : {
        title : "Social Media Information",
        score : 1250,
        form : [
          {
            name: "instagram",
            label: "Instagram",
            type: "text",
          },
          {
            name : "facebook",
            label : "Facebook",
            type : "text"
          },
          {
            name: "twitter",
            label: "Twitter",
            type: "text",
          },
        ]
      },
      serviceInfoForm : {
        title : "Service Information",
        score : 1250,
        form : [
          {
            name : "services",
            label : "Main Service",
            type : "text",
            meta : {
              autocomplete : true,
              options : vendorTypes
            }
          },         
          {
            name : "prices",
            label : "Price Range (naira)",
            type : "select",
            default : "",
            meta : {
              options : this.nigeriaPriceRanges,
              multiple : true
            }
          }
        ]
      }
    }
      

  }

  componentDidMount(){    
    this.setState({
      currentTab : 0,
      disableNextTabButton : false,
      nextButtonText : "NEXT",
      forms : [this.state.contactForm, this.state.locationForm, this.state.socialMediaForm, this.state.serviceInfoForm],
      showReviewPage : false,
      showTabs : true,
      priceRange : this.nigeriaPriceRanges,
      data : {
        email : "",
        password : "",
        currency : "naira"
      },
      optionalFields: ["postalcode", "facebook", "twitter"]
    })
  }

  saveToState = (data, isValid) => {
    const { name, value } = data
    const newData = Object.assign(this.state.data, {[name]: value})  

    if(name=="country"){
      
      if(value.toLowerCase() == "nigeria" && this.state.priceRange!==this.nigeriaPriceRanges){        
        let newServiceForm = Object.assign(this.state.serviceInfoForm, {})    

        newServiceForm.form[1].label="Price Range (naira)"
        newServiceForm.form[1].meta = {
          options : this.nigeriaPriceRanges,
          multiple : true
        }

        this.setState({ 
          serviceInfoForm : newServiceForm,
          priceRange : this.nigeriaPriceRanges,
        })

      }
      else{        
        let newServiceForm = Object.assign(this.state.serviceInfoForm, {}) 
        
        newServiceForm.form[1].label="Price Range (dollars)"

        newServiceForm.form[1].meta = {
          options : this.usPriceRanges,
          multiple : true
        }  
        this.setState({ 
          serviceInfoForm : newServiceForm,
          priceRange : this.usPriceRanges,
        })

      }
    }
    
    this.setState({ 
      data : newData,
      data_status : Object.assign(this.state.data_status, {[name] : isValid})
    });

  }

  formIsValid = (form) => {    
    for(let field in form){
      const currentField = form[field]
      
      if((this.state.optionalFields.indexOf(currentField.name) > -1)
        || this.state.data_status[currentField.name]){
        continue
      }
      else{
        this.setState({
          errorMessage : "Please enter a valid " + currentField.name
        })
        return false
      }
    }

    return true
  }


  nextTab = () => {
    // if(true){
    if(this.formIsValid(this.state.forms[this.state.currentTab].form)){
        this.setState({
          showErrorMessage : false,
          errorMessage : ""
        })

        if(this.state.currentTab == (this.state.forms.length - 1)){
          this.setState({ 
            showReviewPage : true,
            showTabs : false
          })
        } 

        if(this.state.currentTab != (this.state.forms.length - 1)){
          this.setState({      
            currentTab : this.state.currentTab + 1
          }, () => {
            // Check if this is the last tab
            if(this.state.currentTab == (this.state.forms.length - 1)){
              this.setState({ nextButtonText : "FINISH" })
            }        
          })
        }
    }
    else{
      this.setState({
        showErrorMessage : true
      })
    }
  }


  previousTab = () => {
    if(this.state.currentTab != 0){
      this.setState({      
        currentTab : this.state.currentTab - 1,
        nextButtonText : "NEXT",
        showReviewPage : false
      })
    }        
  }

  renderProgressBars = () => {    
    return this.state.forms.map((item, index) => {
      return <div 
              className={"lush-bar mx-auto col-xs-12 mt-3 " + ((index <= this.state.currentTab) ? "filled-bar" : "")}
              key={index}>
              </div>
    })
  }

  renderReviewPage = () => {
    let tokens = 0
    this.state.forms.map((form, id) => {      
      tokens += form.score
    })  
    return (
      <div hidden={!this.state.showReviewPage}>
        <h4 className="earning center">
          You have earned {tokens} lush tokens review your information and submit to redeem them.
        </h4>
        <h1 className="center">REVIEW</h1>
        {this.state.forms.map((form, id) => {            
            return  (
              <div key={id}>
                <div className="center col-xs-12">
                  <hr></hr>
                  <h3>{form.title.toUpperCase()}</h3>
                  <hr></hr>
                </div>  
                {form.form.map((item, id) => {
                  return <FormField 
                          key={id}
                          fieldChange = {this.saveToState}
                          value = {this.state.data[item.name] || item.default || ""}
                          field={item}
                          submitActive={this.state.submit} />
                })}
              </div>
            )
          })}
      </div>
      )
  }

  renderErrorMessage = () => {
    return (
      <div className="error-container" hidden={!this.state.showErrorMessage}>
        {this.state.errorMessage}
      </div>
    )
  }


  submitForm = () => {
    let valid = null
    for(let index in this.state.forms){      
      // if(false){
      if(!this.formIsValid(this.state.forms[index].form)){
        this.setState({
          showErrorMessage : true
        })
        return
      }
    }
    let d = JSON.parse(JSON.stringify(this.state.data));
    let profile = JSON.parse(JSON.stringify(this.state.data));
    profile.sslt = 5000 + "" //Give 5000 for all signups
    d.profile = profile
    d.react = true

    fetch(api + "auth/register", {
      method: 'POST',
      headers: new Headers({
                 'Accept': 'application/json',
                 'Content-Type': 'application/json',
        }),
      body: JSON.stringify(d)
    })
    .then((response) => response.json())
    .then((res) => {
      if (res.message) {
        swal("IMPORTANT!", res.message, "info");
      } else {
        swal("Great work!", "You have submitted your vendor profile. Check your email to finish!", "success");
      }
    })
    .catch((err) => {
      swal("Something went wrong!", String(err), "error");
    });
  }


  render() {
    return (
      <div className="height">
      <hr className="spacer"></hr>
        <div id="tab-container" className="mx-auto"> 
          <div className="row mx-auto col-xs-12 progressSection">            
            {this.renderProgressBars()}            
          </div>

          {this.state.forms.map((form, id) => {
            let pageScores = [0]
            let totalPageScore = 0
            this.state.forms.map((form, id) => {
              pageScores.push(form.score + pageScores[id])
              totalPageScore += form.score
            })                  
            return <Tab
                      index={id}
                      pageScore={pageScores[id]}
                      totalPageScore={totalPageScore}                      
                      key={id}     
                      title={form.title}       
                      tabForm={form.form} 
                      hidden={id!==this.state.currentTab || !this.state.showTabs}
                      onInput={this.saveToState}
                    />
          })}

          {this.renderReviewPage()}

          {this.renderErrorMessage()}

          <div className="center" hidden={!this.state.showTabs}>
            <button onClick={this.previousTab} className="mt-4 lush-btn">           
              <b> BACK </b>
            </button>

            <button onClick={this.nextTab} className="mt-4 ml-1 lush-btn">           
              <b> {this.state.nextButtonText} </b>
            </button>      
          </div>

          <div className="center" hidden={!this.state.showReviewPage}>
            <button onClick={this.submitForm} className="mt-4 lush-btn">           
              <b> SUBMIT </b>
            </button>
          </div>          
        </div> 
        <br></br>  
        <br></br>    

      </div>
      )
  }
};


class Tab extends Component {
  constructor(props){
    super(props)    
    this.state = {
      form : [],
      data : {}
    }
  }

  componentDidMount(){
    this.setState({
      form : this.props.tabForm || []
    })    
  }

  componentWillReceiveProps(nextProps){   
    this.setState({
      form : nextProps.tabForm || []
    })
  }

  saveToState = (data, isValid) => {
    const { name, value } = data

    const newData = Object.assign(this.state.data, {[name]: value})
    
    this.setState({ data : newData });
    
    this.props.onInput(data, isValid)
  }

  render(){
    return (
      <div hidden={this.props.hidden}>
        <div className="center">
          <h4 className="earning">
            You can earn {(this.props.totalPageScore - this.props.pageScore) + " "} Lush Tokens. 
            You have {this.props.pageScore + " "}
          </h4>
          <h6>{this.props.title.toUpperCase()}</h6>
        </div>        
        <hr />
        {this.state.form.map((item, id) => (
            <FormField 
              key={id}
              fieldChange = {this.saveToState}
              value = {this.state.data[item.name] || item.default || ""}
              field={item}/>
          ))}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Signup/Signup.js